/*** IMPORTS FROM imports-loader ***/
var define = false;

import Flickity from 'flickity';

export function homeHeroSlider() {
  var slider = document.querySelector('.homeHero__slider');
  var flkty = new Flickity(slider, {
    // options
    cellAlign: 'left',
    contain: true,
    wrapAround: false,
    prevNextButtons: true,
    pageDots: false,
    autoPlay: 4000
  });

  var tapArea, startX;
  tapArea = document.querySelectorAll('.homeHero__slider');
  startX = 0;
  for (var item of tapArea) {
    item.ontouchstart = function (e) {
      startX = e.touches[0].clientX;
    };
    item.ontouchmove = function (e) {
      if (Math.abs(e.touches[0].clientX - startX) > 5 && e.cancelable) {
        e.preventDefault();
      }
    };
  }
}
